
import { supabase } from '@/integrations/supabase/client';
import { updateUserStreak } from '@/utils/streak-utils';

/**
 * Fetches the current streak for a user
 */
export const fetchUserStreak = async (userId: string) => {
  const { data, error } = await supabase
    .from('user_streaks')
    .select('current_streak')
    .eq('user_id', userId)
    .single();
    
  if (error && error.code !== 'PGRST116') {
    console.error('Error fetching user streak:', error);
    throw error;
  }
  
  return data?.current_streak || 1;
};

/**
 * Updates a user's streak after completing a workout
 */
export const updateStreakAfterWorkout = async (userId: string) => {
  const today = new Date().toISOString().split('T')[0];
  
  // Get the current streak data
  const { data: streakData, error: streakFetchError } = await supabase
    .from('user_streaks')
    .select('*')
    .eq('user_id', userId)
    .single();
    
  if (streakFetchError && streakFetchError.code !== 'PGRST116') {
    console.error('Error fetching user streak:', streakFetchError);
    throw streakFetchError;
  }
  
  const currentDate = new Date();
  const lastActivityDate = streakData?.last_activity_date 
    ? new Date(streakData.last_activity_date) 
    : null;
  
  let newStreak = 1;
  
  if (streakData) {
    if (lastActivityDate) {
      const lastDate = new Date(lastActivityDate);
      lastDate.setHours(0, 0, 0, 0);
      
      const currentDateNormalized = new Date(currentDate);
      currentDateNormalized.setHours(0, 0, 0, 0);
      
      const timeDiff = currentDateNormalized.getTime() - lastDate.getTime();
      const dayDiff = Math.round(timeDiff / (1000 * 3600 * 24));
      
      console.log('Days since last activity:', dayDiff);
      
      if (dayDiff <= 1) {
        newStreak = streakData.current_streak + 1;
      }
    }
  }
  
  const maxStreak = streakData ? Math.max(streakData.max_streak, newStreak) : newStreak;
  
  // Update or create the streak record
  if (streakData) {
    const { error: updateStreakError } = await supabase
      .from('user_streaks')
      .update({
        current_streak: newStreak,
        max_streak: maxStreak,
        last_activity_date: today
      })
      .eq('user_id', userId);
      
    if (updateStreakError) {
      console.error('Error updating streak:', updateStreakError);
      throw updateStreakError;
    }
  } else {
    const { error: insertStreakError } = await supabase
      .from('user_streaks')
      .insert({
        user_id: userId,
        current_streak: newStreak,
        max_streak: newStreak,
        last_activity_date: today
      });
      
    if (insertStreakError) {
      console.error('Error creating new streak:', insertStreakError);
      throw insertStreakError;
    }
  }
  
  return newStreak;
};
